// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"e28403b8","212":"2e1caa1e","236":"999e6c77","299":"6af45035","915":"61ee592d"}[chunkId] + ".chunk.css";
};